// extracted by mini-css-extract-plugin
module.exports = {"company":"Company_company__3tBT0","divider":"Company_divider__1th1N"};